// extracted by mini-css-extract-plugin
module.exports = {"figureContainer":"Bilde_figureContainer__uGiMv","figureSmall":"Bilde_figureSmall__STuns","figureMedium":"Bilde_figureMedium__cm9N1","figureFull":"Bilde_figureFull__ngFx6"};